import React from 'react';

import Button from '@mui/material/Button';
import { alpha } from '@mui/material/styles';

import styled from '../../../styled';
import { colorsPalette } from '../../../theme';

interface SecondaryButtonProps {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'submit' | 'button';
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  children,
  onClick,
  disabled = false,
  type = 'button',
  className,
}) => {
  return (
    <StyledButton
      variant="contained"
      color="secondary"
      className={className}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {children}
    </StyledButton>
  );
};

export default SecondaryButton;

const StyledButton = styled(Button)`
  border-radius: 999em;
  line-height: 1;
  font-weight: bold;
  box-shadow: 0px 3px 6px ${colorsPalette.black};
  text-decoration: none;
  font-size: 16px;

  &.MuiButton-contained {
    border: none;
    padding: 19px 35px;

    ${({ theme }) => theme.breakpoints.up('md')} {
      padding: 15px 32px;
    }
  }

  &.MuiButton-containedSecondary {
    background: ${colorsPalette.blue};

    &:hover {
      background: ${alpha(colorsPalette.blue, 0.8)};
    }
  }
`;
